import { Box, Stack, Typography } from '@mui/material'

import { COLOR_REALLOCATION_PRIMARY } from 'components/reports/Metrics/constants/AllocationStability'

import { AllocationStabilityCards } from './AllocationStabilityCards'
import { AllocationStabilityFilterCriteria } from './AllocationStabilityFilterCriteria'
import { AllocationStabilityFiltersForm } from './AllocationStabilityFilters'

export const AllocationStability = () => (
  <AllocationStabilityFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-start' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Typography variant='h5' fontWeight={700} sx={{ color: COLOR_REALLOCATION_PRIMARY }}>
            Allocation Stability
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Monitor allocation instability across the network.
          </Typography>
        </Box>

        <Stack direction='row' spacing={1} alignItems={{ xs: 'stretch', lg: 'flex-end' }}>
          <AllocationStabilityFiltersForm />
          {/* Temporarily disabled before implementation */}
          {/* <AllocationStabilityExportButton /> */}
        </Stack>
      </Stack>

      <AllocationStabilityCards />
    </Box>
  </AllocationStabilityFilterCriteria>
)
